import React from "react";
import {
  CircularProgress,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PrintIcon from "@material-ui/icons/Print";
import printJS from "print-js";

import { useMagicLink } from "../../intakeQueries";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { getBaseUrl } from "../../../common/util";

export const LabelButton = ({ unitID }: any) => {
  const {
    error: errorLink,
    data: link,
    isLoading: isLoadingLink,
    isError: isErrorLink,
  } = useMagicLink(unitID);

  const pdfUrl = link?.token
    ? `${getBaseUrl()}/units/${unitID}/get_label/?token=${link.token}`
    : "";

  const printLabel = () => {
    if (!pdfUrl) {
      console.error("PDF URL not available for unit:", unitID);
      return;
    }

    printJS({
      printable: pdfUrl,
      type: "pdf",
    });
  };

  if (isErrorLink) {
    return <ErrorMessage error={errorLink} />;
  }

  if (isLoadingLink) {
    return (
      <Button
        variant="contained"
        disabled
      >
        <CircularProgress size={20} />
      </Button>
    );
  }

  return (
    <Button
      className="pdf-print-btn"
      data-unit-id={unitID}
      data-pdf-url={pdfUrl}
      variant="contained"
      startIcon={<PrintIcon />}
      onClick={printLabel}
    />
  );
};